import { ValueOf } from '@clearverify/types';

import { StripeAccountStatus } from 'src/api';
import { ChangeVerifierBillingFormFields } from 'src/types/billing';
import type { SxProp } from 'src/types/mui';

import type { VerifierInputFieldsVariable } from './types';

export const verifierInputFieldsVariables: VerifierInputFieldsVariable[] = [
  {
    label: 'Verification of Income',
    name: ChangeVerifierBillingFormFields.voi,
  },
  {
    label: 'Verification of Employment',
    name: ChangeVerifierBillingFormFields.voe,
  },
  {
    label: 'Reverification',
    name: ChangeVerifierBillingFormFields.reverification,
  },
];

export const ChipStyles: Record<ValueOf<typeof StripeAccountStatus>, SxProp> = {
  [StripeAccountStatus.Restricted]: theme => ({
    backgroundColor: theme.palette.chip?.error?.main,
    color: theme.palette.chip?.error?.contrastText,
    borderColor: theme.palette.chip?.error?.contrastText,
  }),
  [StripeAccountStatus.Pending]: theme => ({
    backgroundColor: theme.palette.chip?.success?.main,
    color: theme.palette.chip?.success?.contrastText,
    borderColor: theme.palette.chip?.success?.contrastText,
  }),
  [StripeAccountStatus.Completed]: theme => ({
    backgroundColor: theme.palette.chip?.success?.main,
    color: theme.palette.chip?.success?.contrastText,
    borderColor: theme.palette.chip?.success?.contrastText,
  }),
  [StripeAccountStatus.NotConnected]: theme => ({
    backgroundColor: theme.palette.chip?.error?.main,
    color: theme.palette.chip?.error?.contrastText,
    borderColor: theme.palette.chip?.error?.contrastText,
  }),
};
